"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateParser = void 0;
const handlebars_1 = __importDefault(require("handlebars"));
const xml_parser_1 = require("./xml-parser");
class TemplateParser {
    constructor(handlebarsHelpers, options) {
        this.handlebars = handlebars_1.default;
        if (handlebarsHelpers) {
            this.handlebars.registerHelper(handlebarsHelpers.reduce((acc, helper) => (acc[helper.name] = (options === null || options === void 0 ? void 0 : options.acceptHash)
                ? helper.delegate
                : (...args) => helper.delegate(...(TemplateParser.parseArgs(helper.name, args))),
                acc), {}));
        }
    }
    parser(template, scope) {
        const compiledTemplate = this.handlebars.compile(template);
        const xml = compiledTemplate(scope);
        return new xml_parser_1.XMLParser().parser(xml);
    }
}
exports.TemplateParser = TemplateParser;
TemplateParser.parseArgs = (name, args = []) => args.map((arg) => (typeof arg === 'object' && (arg === null || arg === void 0 ? void 0 : arg['name']) === name ? undefined : arg));
